import { NgModule } from '@angular/core';

import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { FileDropperModule, MarkdownPipe, MarkdownPipeModule } from '@prism/angular-shared';
import { EditSoftwareRequestDialogComponent } from './edit-software-request-dialog.component';

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FileDropperModule,
        MarkdownPipeModule,
    ],
    exports: [EditSoftwareRequestDialogComponent],
    declarations: [EditSoftwareRequestDialogComponent],
    providers: [],
})
export class EditSoftwareRequestDialogModule { }
